var map = {
	"./de.png": 1045,
	"./en.png": 1046,
	"./es.png": 1047,
	"./fr.png": 1048,
	"./ja.png": 1049,
	"./mk.png": 1050,
	"./pt.png": 1051,
	"./tr.png": 1052,
	"./zh.png": 1053
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1044;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 1044
// module chunks = 0